export const MARKETPLACE_ADDRESS = process.env.REACT_APP_ALCHE_MARKETPLACE
export const ALCHE_TOKEN_ADDRESS = process.env.REACT_APP_ALCHE_TOKEN
export const ALCHERO_ADDRESS = process.env.REACT_APP_ALCHERO
export const MGEM_TOKEN_ADDRESS = process.env.REACT_APP_MGEM_TOKEN
export const MGEM_BRIDGE_ADDRESS = process.env.REACT_APP_MGEM_BRIDGE
